angular.module("vgresiduos").component("goalsReportCustomizedFilter", {
	controller: "GoalsReportCustomizedFilterCtrl",
	templateUrl: "views/report/goals/goalsReportCustomizedFilter/goalsReportCustomizedFilter_template.html",
	bindings: {
		onFilter: "<",
		setterDataToExport: "<",
		setterHeadersToExport: "<"
	}
});
